<div [attr.section-name]="sectionName"
     appIntersectionObserver
     (visibilityChange)="onVisibilityChanged($event)">
  <h3>Media</h3>

  <section>
    <app-editable-textual-input [fieldId]="'logoPhoto'"
                                [subtype]="'link'"
                                [iconName]="'photo_library_outline'"
                                [isFieldWithDataSource]="isFieldWithDataSource('logoPhoto')"
                                [hasActiveConnection]="hasActiveConnection('logoPhoto') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'coverPhoto'"
                                [subtype]="'link'"
                                [isFieldWithDataSource]="isFieldWithDataSource('coverPhoto')"
                                [hasActiveConnection]="hasActiveConnection('coverPhoto') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [fieldId]="'otherPhotos'"
                                [subtype]="'multiline_text'"
                                [isFieldWithDataSource]="isFieldWithDataSource('otherPhotos')"
                                [hasActiveConnection]="hasActiveConnection('otherPhotos') | ngrxPush"
    ></app-editable-textual-input>

  </section>
</div>